import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";

import SideBar from "../../components/Sidebar";
import ProfileService from "../../services/ProfileService";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { APP_INFO } from "../../constants/AppInfo";

import "./Transactions.css"; // Import your CSS file for custom styles
import WalletTab from "./WalletTab";
import RechargeTab from "./RechargeTab";
import BillTab from "./BillTab";

const Transactions = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [gender, setGender] = useState();
  const [activeTab, setActiveTab] = useState("wallet"); // default tab

  const nameRef = useRef();
  const emailRef = useRef();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await ProfileService.fetch();
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        var data = responseData.data;
        setData(data);
        setGender(data.gender);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Request Failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      {loading && <LoadingScreen />}
      <div className="row">
        <SideBar />
        <div className="col-md-9 mb-3">
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <h5 className="card-title pb-2">Transactions</h5>

              {/* Bootstrap Nav Tabs */}
              {/* Centered and Stylish Tabs */}

              <div className="flat-tabs">
                <button
                  className={activeTab === "wallet" ? "active" : ""}
                  onClick={() => setActiveTab("wallet")}
                >
                  Transactions
                </button>
                <button
                  className={activeTab === "recharge" ? "active" : ""}
                  onClick={() => setActiveTab("recharge")}
                >
                  Recharge
                </button>
                <button
                  className={activeTab === "bill" ? "active" : ""}
                  onClick={() => setActiveTab("bill")}
                >
                  Bill Payment
                </button>
              </div>

              {/* Tab Content */}
              <div className="tab-content pt-2">
                {activeTab === "wallet" && (
                  <div className="tab-pane active">
                    <WalletTab />
                  </div>
                )}
                {activeTab === "recharge" && (
                  <div className="tab-pane active">
                    <RechargeTab />
                  </div>
                )}
                {activeTab === "bill" && (
                  <div className="tab-pane active">
                    <BillTab />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>{" "}
        {/* end col-md-9 */}
      </div>
    </div>
  );
};

export default Transactions;
